export default __webpack_public_path__ + "static/media/Noto-Sans-Bengali-Regular.31d6cfe0.ttf";